export const selectClass =
  "min-h-[44px] rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-navy-500 focus:ring-1 focus:ring-navy-500 focus:outline-none";
